(function($, root, undefined) {       

    // Parse the URL
    getParameterByName = function(name) {
        query = window.location.search.toString();
        name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
        var regexS = "[\\?&]" + name + "=([^&#]*)";
        var regex = new RegExp(regexS);
        results = regex.exec(query);
        if (results === null) return "";
        else return decodeURIComponent(results[1].replace(/\+/g, " "));
    }
    function formatEURFromCents(cents) {
        var n = Number(cents);
        if (!isFinite(n)) n = 0;

        // cents -> euros
        var euros = n / 100;

        // Force "de-DE" style: 1.234,56
        return euros.toLocaleString("de-DE", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }) + " €";
        }

    jQuery(document).ready(function(){
        
        // Give the URL parameters variable names
        var hero_id = getParameterByName('hid');
        var hero_sup = getParameterByName('hsup');
        var hero_product_primary_title = getParameterByName('hproduct_primary_title');
        var hero_product_secondarytitle = getParameterByName('secondarytitle');
        var hero_pricing = getParameterByName('hero_pricing');

        var gift_id = getParameterByName('gift_id');
        var gift_title = getParameterByName('gtitle');
        var gift_title = "f59"; // Delete
        var gift_id = "56554760765813"; //delete




      console.log("gift_title 1", gift_title);
        var gift_stat = getParameterByName('gstat');
        var recommendation_hls = getParameterByName('rhls');
        var all_rec_product_ids = getParameterByName('all_rpids');
        var productIds = [];  // Array to accumulate variant IDs


      // Map hero_sup to product handle
      var productHandle;
      if (hero_sup === 'F59' || hero_sup === 'f59') {
          productHandle = 'f59-hydroxytyrosol-corrective-serum-face';
      } else if (hero_sup === 'F06' || hero_sup === 'f06') {
          productHandle = 'f06-serum-face-cell-active'; // Replace with the actual product handle for F64
      }
      
      // Check if productHandle is defined before checking availability
      if (productHandle) {
          checkProductAvailability(productHandle).then(function(isAvailable) {
              var availabilityElement = document.getElementById('heroProductAvailability');
              var HeroButtonElement = document.getElementById('heroButton');

              if (isAvailable) {
                  availabilityElement.innerText = 'ADD TO CART';
              } else {
                  HeroButtonElement.style.background = 'black';
                  availabilityElement.innerText = 'SOLD OUT';
                  HeroButtonElement.style.cursor = 'unset';
                  HeroButtonElement.disabled = true; 

              }
          }).catch(function(error) {
              console.log('Error:', error);
          });
      } else {
          console.log('No valid product handle found for hero_sup:', hero_sup);
      }
      
      // Function to check product availability
      function checkProductAvailability(productHandle) {
          return new Promise(function(resolve, reject) {
              // Construct the URL to fetch product data
              var productUrl = '/products/' + productHandle + '.js';
      
              // Fetch the product data
              jQuery.getJSON(productUrl, function(product) {
                  // Check the availability of the first variant
                  if (product.variants[0].available) {
                      console.log('Product:', product.title, 'is available');
                      resolve(true);
                  } else {
                      console.log('Product:', product.title, 'is sold out');
                      resolve(false);
                  }
              }).fail(function() {
                  console.error('Failed to retrieve product data for handle:', productHandle);
                  reject(false);
              });
          });
      }
      
        // Set the cookies
        if(typeof hero_id != 'undefined' && hero_id != null && hero_id != "") {
            Cookies.set('hero_id', hero_id, { expires: 7 });
        }
        if(typeof hero_sup != 'undefined' && hero_sup != null && hero_sup != "") {
            Cookies.set('hero_sup', hero_sup, { expires: 7 });
        }
        if(typeof hero_product_primary_title != 'undefined' && hero_product_primary_title != null && hero_product_primary_title != "") {
            Cookies.set('hero_product_primary_title', hero_product_primary_title, { expires: 7 });
        }
        if(typeof hero_product_secondarytitle != 'undefined' && hero_product_secondarytitle != null && hero_product_secondarytitle != "") {
            Cookies.set('hero_product_secondarytitle', hero_product_secondarytitle, { expires: 7 });
        }
        if(typeof hero_pricing != 'undefined' && hero_pricing != null && hero_pricing != "") {
            Cookies.set('hero_pricing', hero_pricing, { expires: 7 });
        }

        if(typeof gift_id != 'undefined' && gift_id != null && gift_id != "") {
            Cookies.set('gift_id', gift_id, { expires: 7 });
        }
        if(typeof gift_title != 'undefined' && gift_title != null && gift_title != "") {
            Cookies.set('gift_title', gift_title, { expires: 7 });
        }
        if(typeof gift_stat != 'undefined' && gift_stat != null && gift_stat != "") {
            Cookies.set('gift_stat', gift_stat, { expires: 365 });
        }

        if(typeof recommendation_hls != 'undefined' && recommendation_hls != null && recommendation_hls != "") {
            Cookies.set('recommendation_hls', recommendation_hls, { expires: 7 });
        }
        if(typeof all_rec_product_ids != 'undefined' && all_rec_product_ids != null && all_rec_product_ids != "") {
            Cookies.set('all_rec_product_ids', all_rec_product_ids, { expires: 7 });
        }

        // Grab the cookie value and set the form field values
        var hid = Cookies.get('hero_id');
        var hsup = Cookies.get('hero_sup');
        var hppt = Cookies.get('hero_product_primary_title');
        var hpset = Cookies.get('hero_product_secondarytitle');
        var hpricing = Cookies.get('hero_pricing');

        var gid = Cookies.get('gift_id');
        var gtitle = Cookies.get('gift_title');
         var gtitle ="f59"; //delete
       var gid = "56554760765813"; //delete




        var gstat = Cookies.get('gift_stat');

        var arids = Cookies.get('all_rec_product_ids');
        var rhls = Cookies.get('recommendation_hls');
        var rhls_arr = rhls.split(",");

        var curr_iso = jQuery("#result-hero-product").data("ciso_code");
        var morning_label = jQuery("#regime-result-recommendation").data("morning_label");
        var evening_label = jQuery("#regime-result-recommendation").data("evening_label");
        var week_label = jQuery("#regime-result-recommendation").data("week_label");
        var morning_or_label = jQuery("#regime-result-recommendation").data("morning_or_label");
        var rc_lmore = jQuery("#regime-result-recommendation").data("rc_lmore");

        var rec_metas = JSON.parse(jQuery("#products_meta_json").html());

        // Hero Product

        jQuery("#result-hero-product .product-images .single-img." + hsup + "-product").removeClass("hide");
        jQuery("#result-hero-product .product-single__title .product_prefix").text(hsup);
        jQuery("#result-hero-product .product-single__title .product_primary_title").text(hppt);
        jQuery("#result-hero-product .product-single__title .product_secondarytitle").text(hpset);

        jQuery("#result-hero-product .product-meta .hero-pricing").html(hpricing);
        jQuery("#result-hero-product .product-description ." + hsup + "-product").removeClass("hide");

        jQuery("#result-hero-product .add-to-cart-button form").attr("onsubmit", "CartHelper.addToCart(event,"+ hid +",100, '"+ curr_iso +"', {'brain_product': true,'brain_gift_id': "+ gid +"})");

        jQuery("#result-hero-product-area").removeClass("hide");

        // Gift Product
        jQuery("#result-gift-product .gift-content .gift-product-image-group .gift-box .product-img."+ gtitle +"-product").removeClass("hide");
        jQuery("#result-gift-product .gift-product-details .product-title."+ gtitle +"-product").removeClass("hide");

        if(gstat) {
            jQuery("#result-gift-product-form").attr("onsubmit", "CartHelper.addToCart(event,"+ gid +",100, '"+ curr_iso +"', {'brain_product': true,'brain_gift_id': "+ gid +"})");
        } else {
            jQuery("#result-gift-product .gift-content .gift-product-details").append("<p class='no-gift-notice'>You already purchased this Gift.</p>")
        }

        jQuery("#result-gift-product").removeClass("hide");

        if(rhls_arr.length > 0){
            for (var i = 0; i < rhls_arr.length; i++) {
                if(rhls_arr[i] != "" && rhls_arr[i] != " "){
                    jQuery.getJSON('/products/' + rhls_arr[i] + '.js', function (product) {
                        var single_rc = '',
                            product_box_title = '',
                            application_type ='',
                            add_to_cart_label = '',
                            current_variant_id,
                            product_link = '',
                            product_price,
                            product_fimg = '',
                            product_title,
                            info_prefix = '',
                            info_primarytitle = '',
                            info_secondarytitle = '',
                            info_excerpt = '',
                            unit_price_measurement_value = '',
                            unit_price_measurement_unit = '',
                            unit_price = '',
                            unit_price_reference_value = '',
                            unit_price_base_unit = '';

                        current_variant_id = product.variants[0].id;
                        console.log("current variant id: ", current_variant_id);
                        productIds.push(current_variant_id);
                        console.log("Product IDs: ", productIds);

                      // After pushing the new product ID, stringify the updated productIds array
                        var productIdsString = JSON.stringify(productIds);
                        console.log("product id string: ", productIdsString);
        
                        // Set the updated productIdsString in the onclick attribute
                        jQuery("[data-multi-products-addtocart]").attr("onclick", "CartHelper.addToMultiItemsCart(event, '" + curr_iso + "', " + productIdsString + ", " + gift_id + ")");
        
                        // Show the action buttons after the product information is retrieved and the onclick is set
                        jQuery(".result-recommendation .action-buttons").removeClass("hide");
                      
                        product_link = product.url;
console.log("curr_iso:", curr_iso);
console.log("Shopify.money_format:", Shopify.money_format);

                        product_price = formatEURFromCents(product.variants[0].price);
                        product_fimg = product.featured_image;
                        product_title = product.title;

                        cal_price = '';


                        switch(product.handle){
                            case "f38-reinigungsgel-purifying":
                              product_box_title= 'gentle and thorough cleaning';
                              application_type= "morgens_abends";
                              break;
                            case "f71-reinigungsgel-hydroxytyrosol-corrective":
                              product_box_title= 'gentle and thorough cleaning';
                              application_type= "morgens_abends";
                              break;
                            case "f72-reinigungsol-hydroxytyrosol-corrective":
                              product_box_title= 'nourishing and deep pore cleaning';
                              application_type= "morgens_abends";
                              break;
                            case "f78-arbequina-cleansing-oil":
                              product_box_title= 'nourishing and deep pore cleaning';
                              application_type= "morgens_abends";
                              break;
                            case "f11-facial-toner":
                              product_box_title= 'TONES, STRENGTHENS, AND REFRESHES';
                              application_type= "morgens_abends";
                              break;
                            case "f67-hydroxytyrosol-corrective-facial-tonic":
                              product_box_title= 'SOOTHES, SMOOTHES, AND BRIGHTENS';
                              application_type= "morgens_abends";
                              break;
                            case "f10-face-peeling-olive-core":
                              product_box_title= 'GENTLE EXFOLIATION AND PROTECTION';
                              application_type= "2Woche";
                              break;
                            case "f18-black-olive-face-mask":
                              product_box_title= 'MOISTURIZES, REJUVENATES, AND PROTECTS';
                              application_type= "2Woche";
                              break;
                            case "f77-olive-matcha-face-mask":
                              product_box_title= 'SOOTHES, NOURISHES, AND PROTECTS';
                              application_type= "2Woche";
                              break;
                            case "f76-honey-enzyme-face-mask":
                              product_box_title= 'EXFOLIATES, SOOTHES, AND MOSITURIZES';
                              application_type= "2Woche";
                              break;
                            case "f06-serum-face-cell-active":
                              product_box_title= 'STRENGTHENS, TIGHTENS, AND RENEWS';
                              application_type= "morgens_abends";
                              break;  
                            case "f59-hydroxytyrosol-corrective-serum-face":
                              product_box_title= 'SMOOTHES, TIGHTENS, AND PROTECTS';
                              application_type= "morgens_abends";
                              break;
                            case "f63-cell-active-face-oil-serum":
                              product_box_title= 'Noticeable tightening and elasticity';
                              application_type= "morgens_abends";
                              break;
                            case "f82-green-retinol-face-elixir":
                              product_box_title= 'Noticeable tightening and elasticity';
                              application_type= "morgens_abends";
                              break;
                            case "f05-face-cream-anti-oxidant":
                              product_box_title= 'MOISTURIZES, PLUMPS, AND PROTECTS';
                              application_type= "morgens_abends";
                              break;
                            case "f07-face-cream-anti-aging":
                              product_box_title= 'intensive moisture and care';
                              application_type= "morgens_abends";
                              break;
                            case "f08-face-cream-cell-active":
                              product_box_title= 'intensive moisture and care';
                              application_type= "morgens_abends";
                              break;
                            case "f42-hydroxytyrosol-corrective-face-cream":
                              product_box_title= 'MOISTURIZES, EVENS TONE, AND PROTECTS';
                              application_type= "morgens_abends";
                              break;
                            case "f74-regeneration-intense-face-cream":
                              product_box_title= 'REJUVENATES, HARMONIZES, AND PROTECTS';
                              application_type= "morgens_abends";
                              break;
                            case "f09-augencreme-anti-wrinkle":
                              product_box_title= 'intensive moisture and care';
                              application_type= "morgens_abends";
                              break;
                            case "f60-hydroxytyrosol-corrective-eye-cream":
                              product_box_title= 'SMOOTHES, TIGHTENS, AND MOISTURIZES';
                              application_type= "morgens_abends";
                              break;
                            case "i66-the-beauty-fountain":
                              product_box_title= 'Collagen + Hydroxytyrosol Booster';
                              application_type= "morgens_oder_abends";
                              break;
                            case "i70-the-beauty-molecule":
                              product_box_title= 'Hyaluron + Hydroxytyrosol Booster';
                              application_type= "morgens_oder_abends";
                              break;
                            case "f81-aha-ht-serum-face":
                              product_box_title= 'Visible skin tightening overnight';
                              application_type= "abends-ersetzt";
                              break;
                            default:
                              product_box_title= 'gentle and thorough cleaning';
                              application_type= "morgens_abends";
                              break;                
                        }

    // Check if the user's language is set to Spanish
var isSpanish = false;
if (sessionStorage.getItem('otpLang') === 'es') {
    isSpanish = true;
}

// Loop through rec_metas to find and assign the correct values
for (var j = 0; j < rec_metas.length; j++) {
    // Ensure the current rec_metas item exists and has a matching handle
    if (rec_metas[j] && rec_metas[j].p_handle === product.handle) {
        // Assign translated values if the locale is Spanish and the translated fields exist, with proper safeguards
        info_prefix = (isSpanish && rec_metas[j].hasOwnProperty('info_prefix_es') && rec_metas[j].info_prefix_es) 
                      ? rec_metas[j].info_prefix_es 
                      : (rec_metas[j].hasOwnProperty('info_prefix') ? rec_metas[j].info_prefix : '');

        info_primarytitle = (isSpanish && rec_metas[j].hasOwnProperty('info_primarytitle_es') && rec_metas[j].info_primarytitle_es) 
                            ? rec_metas[j].info_primarytitle_es 
                            : (rec_metas[j].hasOwnProperty('info_primarytitle') ? rec_metas[j].info_primarytitle : '');

        info_secondarytitle = (isSpanish && rec_metas[j].hasOwnProperty('info_secondarytitle_es') && rec_metas[j].info_secondarytitle_es) 
                              ? rec_metas[j].info_secondarytitle_es 
                              : (rec_metas[j].hasOwnProperty('info_secondarytitle') ? rec_metas[j].info_secondarytitle : '');

        info_excerpt = (isSpanish && rec_metas[j].hasOwnProperty('info_excerpt_es') && rec_metas[j].info_excerpt_es) 
                       ? rec_metas[j].info_excerpt_es 
                       : (rec_metas[j].hasOwnProperty('info_excerpt') ? rec_metas[j].info_excerpt : '');
    }
}


                        if(product.variants[0].unit_price){
                            unit_price = formatEURFromCents(product.variants[0].unit_price);
                        }
if (product.variants[0].unit_price_measurement) {

  const upm = product.variants[0].unit_price_measurement;

  // PACK SIZE (what you want to show: 60 mL)
  if (upm.quantity_value) {
    unit_price_measurement_value = parseInt(upm.quantity_value, 10);
  }

  if (upm.quantity_unit) {
    unit_price_measurement_unit =
      upm.quantity_unit === "ml" ? "mL" : upm.quantity_unit;
  }

  // UNIT PRICE (€/1 L) — optional, only if you actually want it
  if (upm.reference_value && upm.reference_unit) {
    unit_price_reference_value = upm.reference_value;
  }
}

                        unit_price_base_unit =
  '<span data-unit-price-base-unit>' +
  unit_price_measurement_value + ' ' + unit_price_measurement_unit +
  '</span>';


                        if(unit_price_measurement_value != ''){
                            cal_price += unit_price_measurement_value;
                        }
                        if(unit_price_measurement_unit != ''){
                            cal_price += ' ' + unit_price_measurement_unit + ' - ';
                        }
                        cal_price += product_price + '<span class="text-muted fs-14 fw-400">' + unit_price_base_unit;
                        if(unit_price != ''){
                            cal_price += ' - ' + unit_price + '</span>';
                        }


                        if(product.variants[0].available){
                            add_to_cart_label = 'add to cart';
                        } else {
                            add_to_cart_label = 'sold out';
                        }
                        single_rc += `
                            <div class="single-box-product">
                                <div class="box-title">
                                    <h3 class="title text-uppercase">${ product_box_title }</h3>
                                </div>
                                <div class="box-application">
                        `;

                        if(application_type === 'morgens_abends'){
                            single_rc += `
                                    <span class="icon">
                                        <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M1.92793 10.4494C1.72562 10.4014 1.51312 10.3396 1.28018 10.2614C1.12717 10.216 0.958495 10.2573 0.8561 10.3801C0.753705 10.5029 0.738676 10.6754 0.818101 10.8153C1.78684 12.5121 3.38006 13.7789 5.23773 14.3459C5.39225 14.3931 5.54832 14.4353 5.70625 14.4728C9.79248 15.438 13.866 13.0663 14.8151 9.01918C15.6231 5.57369 13.8866 1.8368 10.6543 0.319914C10.5085 0.252562 10.3348 0.278504 10.2186 0.388775C10.1025 0.498933 10.0673 0.668821 10.1303 0.81648C10.7271 2.21436 10.9547 3.79712 10.6116 5.26057C9.71857 9.06853 5.77153 11.3573 1.92793 10.4494ZM11.3646 5.49038C11.6655 4.20647 11.5486 2.76832 11.1957 1.50669C13.5322 3.05754 14.7112 6.02172 14.0621 8.7893C13.2101 12.4227 9.54961 14.5886 5.88224 13.7223C4.36167 13.3631 3.00724 12.4864 2.05114 11.2645C6.21285 12.0836 10.3977 9.61311 11.3646 5.49038Z" fill="#222222"/>
                                        </svg>
                                    </span>
                                    <span class="label">${ morning_label }</span>
                                    <span class="sign" style="font-size: 14px;">+</span>
                                    <span class="icon">
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M19.5455 10.4545H17.7273C17.4763 10.4545 17.2728 10.251 17.2728 9.99996C17.2728 9.749 17.4763 9.54545 17.7273 9.54545H19.5455C19.7965 9.54545 20 9.74905 20 9.99996C20 10.251 19.7965 10.4545 19.5455 10.4545ZM16.0549 17.1447L14.7971 15.8868C14.6234 15.7131 14.6234 15.4318 14.7971 15.2582C14.9708 15.0845 15.2523 15.0845 15.426 15.2582L16.6838 16.5158C16.8573 16.6895 16.8573 16.971 16.6838 17.1447C16.5101 17.3185 16.2285 17.3185 16.0549 17.1447ZM15.426 5.196C15.2523 5.36941 14.9708 5.36941 14.7971 5.196C14.6234 5.02218 14.6234 4.74073 14.7971 4.56723L16.0549 3.30941C16.2285 3.13564 16.5101 3.13564 16.6838 3.30941C16.8573 3.48309 16.8573 3.76463 16.6838 3.93832L15.426 5.196ZM10 15.9091C6.73644 15.9091 4.09084 13.2635 4.09084 9.99996C4.09084 6.73655 6.73644 4.09091 10 4.09091C13.2636 4.09091 15.9092 6.73655 15.9092 9.99996C15.9092 13.2635 13.2636 15.9091 10 15.9091ZM10 4.99977C7.23858 4.99977 4.99994 7.23841 4.99994 9.99982C4.99994 12.761 7.23858 14.9999 10 14.9999C12.7615 14.9999 14.9999 12.761 14.9999 9.99982C14.9999 7.23841 12.7615 4.99977 10 4.99977ZM10 2.72732C9.74895 2.72732 9.5455 2.52373 9.5455 2.27273V0.454501C9.5455 0.203547 9.74895 0 10 0C10.251 0 10.4545 0.203592 10.4545 0.454501V2.27273C10.4545 2.52373 10.251 2.72732 10 2.72732ZM0.454503 9.54545H2.27274C2.52374 9.54545 2.72724 9.74905 2.72724 9.99996C2.72724 10.251 2.52374 10.4545 2.27274 10.4545H0.454503C0.203457 10.4545 0 10.251 0 9.99996C0 9.74905 0.203457 9.54545 0.454503 9.54545ZM2.84833 3.30945C3.02202 3.13568 3.30361 3.13568 3.47724 3.30945L4.73502 4.56727C4.9087 4.74077 4.9087 5.02223 4.73502 5.19604C4.56139 5.36945 4.2798 5.36945 4.10616 5.19604L2.84833 3.93837C2.6747 3.76464 2.6747 3.48314 2.84833 3.30945ZM4.10616 15.2582C4.2798 15.0845 4.56139 15.0845 4.73502 15.2582C4.9087 15.4318 4.9087 15.7131 4.73502 15.8868L3.47724 17.1447C3.30361 17.3185 3.02202 17.3185 2.84833 17.1447C2.6747 16.971 2.6747 16.6895 2.84833 16.5158L4.10616 15.2582ZM10 17.2727C10.251 17.2727 10.4545 17.4763 10.4545 17.7273V19.5454C10.4545 19.7964 10.251 20 10 20C9.74895 20 9.5455 19.7964 9.5455 19.5454V17.7273C9.5455 17.4763 9.74895 17.2727 10 17.2727Z" fill="#222222"/>
                                        </svg>
                                    </span>
                                    <span class="label">${ evening_label }</span>`;                            
                        }

                        if(application_type === '2Woche'){
                            single_rc += `<span class="label">2 x ${ week_label }</span>`;                            
                        }

                        if(application_type === 'morgens_oder_abends'){
                            single_rc += `
                                    <span class="icon">
                                        <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M1.92793 10.4494C1.72562 10.4014 1.51312 10.3396 1.28018 10.2614C1.12717 10.216 0.958495 10.2573 0.8561 10.3801C0.753705 10.5029 0.738676 10.6754 0.818101 10.8153C1.78684 12.5121 3.38006 13.7789 5.23773 14.3459C5.39225 14.3931 5.54832 14.4353 5.70625 14.4728C9.79248 15.438 13.866 13.0663 14.8151 9.01918C15.6231 5.57369 13.8866 1.8368 10.6543 0.319914C10.5085 0.252562 10.3348 0.278504 10.2186 0.388775C10.1025 0.498933 10.0673 0.668821 10.1303 0.81648C10.7271 2.21436 10.9547 3.79712 10.6116 5.26057C9.71857 9.06853 5.77153 11.3573 1.92793 10.4494ZM11.3646 5.49038C11.6655 4.20647 11.5486 2.76832 11.1957 1.50669C13.5322 3.05754 14.7112 6.02172 14.0621 8.7893C13.2101 12.4227 9.54961 14.5886 5.88224 13.7223C4.36167 13.3631 3.00724 12.4864 2.05114 11.2645C6.21285 12.0836 10.3977 9.61311 11.3646 5.49038Z" fill="#222222"/>
                                        </svg>
                                    </span>
                                    <span class="label">${ morning_or_label }</span>
                                    <span class="icon">
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M19.5455 10.4545H17.7273C17.4763 10.4545 17.2728 10.251 17.2728 9.99996C17.2728 9.749 17.4763 9.54545 17.7273 9.54545H19.5455C19.7965 9.54545 20 9.74905 20 9.99996C20 10.251 19.7965 10.4545 19.5455 10.4545ZM16.0549 17.1447L14.7971 15.8868C14.6234 15.7131 14.6234 15.4318 14.7971 15.2582C14.9708 15.0845 15.2523 15.0845 15.426 15.2582L16.6838 16.5158C16.8573 16.6895 16.8573 16.971 16.6838 17.1447C16.5101 17.3185 16.2285 17.3185 16.0549 17.1447ZM15.426 5.196C15.2523 5.36941 14.9708 5.36941 14.7971 5.196C14.6234 5.02218 14.6234 4.74073 14.7971 4.56723L16.0549 3.30941C16.2285 3.13564 16.5101 3.13564 16.6838 3.30941C16.8573 3.48309 16.8573 3.76463 16.6838 3.93832L15.426 5.196ZM10 15.9091C6.73644 15.9091 4.09084 13.2635 4.09084 9.99996C4.09084 6.73655 6.73644 4.09091 10 4.09091C13.2636 4.09091 15.9092 6.73655 15.9092 9.99996C15.9092 13.2635 13.2636 15.9091 10 15.9091ZM10 4.99977C7.23858 4.99977 4.99994 7.23841 4.99994 9.99982C4.99994 12.761 7.23858 14.9999 10 14.9999C12.7615 14.9999 14.9999 12.761 14.9999 9.99982C14.9999 7.23841 12.7615 4.99977 10 4.99977ZM10 2.72732C9.74895 2.72732 9.5455 2.52373 9.5455 2.27273V0.454501C9.5455 0.203547 9.74895 0 10 0C10.251 0 10.4545 0.203592 10.4545 0.454501V2.27273C10.4545 2.52373 10.251 2.72732 10 2.72732ZM0.454503 9.54545H2.27274C2.52374 9.54545 2.72724 9.74905 2.72724 9.99996C2.72724 10.251 2.52374 10.4545 2.27274 10.4545H0.454503C0.203457 10.4545 0 10.251 0 9.99996C0 9.74905 0.203457 9.54545 0.454503 9.54545ZM2.84833 3.30945C3.02202 3.13568 3.30361 3.13568 3.47724 3.30945L4.73502 4.56727C4.9087 4.74077 4.9087 5.02223 4.73502 5.19604C4.56139 5.36945 4.2798 5.36945 4.10616 5.19604L2.84833 3.93837C2.6747 3.76464 2.6747 3.48314 2.84833 3.30945ZM4.10616 15.2582C4.2798 15.0845 4.56139 15.0845 4.73502 15.2582C4.9087 15.4318 4.9087 15.7131 4.73502 15.8868L3.47724 17.1447C3.30361 17.3185 3.02202 17.3185 2.84833 17.1447C2.6747 16.971 2.6747 16.6895 2.84833 16.5158L4.10616 15.2582ZM10 17.2727C10.251 17.2727 10.4545 17.4763 10.4545 17.7273V19.5454C10.4545 19.7964 10.251 20 10 20C9.74895 20 9.5455 19.7964 9.5455 19.5454V17.7273C9.5455 17.4763 9.74895 17.2727 10 17.2727Z" fill="#222222"/>
                                        </svg>
                                    </span>
                                    <span class="label">${ evening_label }</span>`;                            
                        }

                        if(application_type === 'abends-ersetzt'){
                            single_rc += `
                                    <span class="icon">
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M19.5455 10.4545H17.7273C17.4763 10.4545 17.2728 10.251 17.2728 9.99996C17.2728 9.749 17.4763 9.54545 17.7273 9.54545H19.5455C19.7965 9.54545 20 9.74905 20 9.99996C20 10.251 19.7965 10.4545 19.5455 10.4545ZM16.0549 17.1447L14.7971 15.8868C14.6234 15.7131 14.6234 15.4318 14.7971 15.2582C14.9708 15.0845 15.2523 15.0845 15.426 15.2582L16.6838 16.5158C16.8573 16.6895 16.8573 16.971 16.6838 17.1447C16.5101 17.3185 16.2285 17.3185 16.0549 17.1447ZM15.426 5.196C15.2523 5.36941 14.9708 5.36941 14.7971 5.196C14.6234 5.02218 14.6234 4.74073 14.7971 4.56723L16.0549 3.30941C16.2285 3.13564 16.5101 3.13564 16.6838 3.30941C16.8573 3.48309 16.8573 3.76463 16.6838 3.93832L15.426 5.196ZM10 15.9091C6.73644 15.9091 4.09084 13.2635 4.09084 9.99996C4.09084 6.73655 6.73644 4.09091 10 4.09091C13.2636 4.09091 15.9092 6.73655 15.9092 9.99996C15.9092 13.2635 13.2636 15.9091 10 15.9091ZM10 4.99977C7.23858 4.99977 4.99994 7.23841 4.99994 9.99982C4.99994 12.761 7.23858 14.9999 10 14.9999C12.7615 14.9999 14.9999 12.761 14.9999 9.99982C14.9999 7.23841 12.7615 4.99977 10 4.99977ZM10 2.72732C9.74895 2.72732 9.5455 2.52373 9.5455 2.27273V0.454501C9.5455 0.203547 9.74895 0 10 0C10.251 0 10.4545 0.203592 10.4545 0.454501V2.27273C10.4545 2.52373 10.251 2.72732 10 2.72732ZM0.454503 9.54545H2.27274C2.52374 9.54545 2.72724 9.74905 2.72724 9.99996C2.72724 10.251 2.52374 10.4545 2.27274 10.4545H0.454503C0.203457 10.4545 0 10.251 0 9.99996C0 9.74905 0.203457 9.54545 0.454503 9.54545ZM2.84833 3.30945C3.02202 3.13568 3.30361 3.13568 3.47724 3.30945L4.73502 4.56727C4.9087 4.74077 4.9087 5.02223 4.73502 5.19604C4.56139 5.36945 4.2798 5.36945 4.10616 5.19604L2.84833 3.93837C2.6747 3.76464 2.6747 3.48314 2.84833 3.30945ZM4.10616 15.2582C4.2798 15.0845 4.56139 15.0845 4.73502 15.2582C4.9087 15.4318 4.9087 15.7131 4.73502 15.8868L3.47724 17.1447C3.30361 17.3185 3.02202 17.3185 2.84833 17.1447C2.6747 16.971 2.6747 16.6895 2.84833 16.5158L4.10616 15.2582ZM10 17.2727C10.251 17.2727 10.4545 17.4763 10.4545 17.7273V19.5454C10.4545 19.7964 10.251 20 10 20C9.74895 20 9.5455 19.7964 9.5455 19.5454V17.7273C9.5455 17.4763 9.74895 17.2727 10 17.2727Z" fill="#222222"/>
                                        </svg>
                                    </span>
                                    <span class="label">${ evening_label } - ${ section.settings.box_app_evening_rep_label }</span>`;                         
                        }

                        single_rc += `
                                </div>
                                <div class="box-product-content flex-grow-1 d-flex">
                                    <div class="row">
                                        <div class="col-12 col-lg-4 col-md-6 d-flex align-items-end">
                                            <div class="single-product-img">
                                                <img src="${ product_fimg }" class="product-featured-img lazyload" />
                                            </div>
                                        </div>
                                        <div class="col-12 col-lg-8 col-md-6 d-flex justify-content-center align-items-center center">
                                            <div class="product-content">
                                                <p class="branding text-uppercase">Oliveda</p>
                                                <h4 class="product-single__title dz-oswald-font fs-25 text-uppercase lh-base mb-0 mt-0">
                                                    ${info_prefix} ${info_primarytitle} ${info_secondarytitle}
                                                </h4>
                                                <div class="product-reviews">
                                                    <span>
                                                      <svg width="78" height="13" viewBox="0 0 78 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M5.90952 0.611816L7.12649 5.35744L11.8187 4.86545L7.98856 7.49434L9.56144 11.7478L5.90952 8.62724L2.25708 11.7478L3.83031 7.49434L0 4.86545L4.69221 5.35744L5.90952 0.611816Z" fill="black"/>
                                                        <path d="M22.4543 0.611816L23.6712 5.35744L28.3634 4.86545L24.5333 7.49434L26.1062 11.7478L22.4543 8.62724L18.802 11.7478L20.3751 7.49434L16.5449 4.86545L21.2371 5.35744L22.4543 0.611816Z" fill="black"/>
                                                        <path d="M39.0011 0.611816L40.2181 5.35744L44.9103 4.86545L41.0802 7.49434L42.6532 11.7478L39.0011 8.62724L35.3489 11.7478L36.9219 7.49434L33.0918 4.86545L37.784 5.35744L39.0011 0.611816Z" fill="black"/>
                                                        <path d="M55.5443 0.611816L56.7611 5.35744L61.4533 4.86545L57.6232 7.49434L59.1962 11.7478L55.5443 8.62724L51.8918 11.7478L53.4649 7.49434L49.6348 4.86545L54.327 5.35744L55.5443 0.611816Z" fill="black"/>
                                                        <path d="M72.0912 0.611816L73.3081 5.35744L78.0002 4.86545L74.1702 7.49434L75.7431 11.7478L72.0912 8.62724L68.4387 11.7478L70.0118 7.49434L66.1816 4.86545L70.8738 5.35744L72.0912 0.611816Z" fill="black"/>
                                                      </svg>
                                                    </span>
                                                </div>
                                                <div class="product-desc">
                                                    <p>${info_excerpt}</p>
                                                </div>
                                                <style>
                                                .text-muted.fs-14.fw-400 {
                                                    display: none !important;
                                                }
                                                </style>
                                                <div class="product-price" id="price2">
                                                    <p>${cal_price}</p>
                                                </div>
                                                <div class="read-more">
                                                    <a href="${ product_link }" target="_blank">${ rc_lmore }</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="box-product-submit-btn text-uppercase center">
                                    <form class="needs-validation was-validated" action="javascript:;" onsubmit="CartHelper.addToCart(event,${current_variant_id},100,'${curr_iso}',{'brain_product': true,'brain_gift_id': ${gid} })" novalidate>
                                        <input data-dz-qty-selector type="number" required id="Quantity-product-template-ladope" name="quantity" value="1" min="1" max="" pattern="[0-9]*" class="product-form__input product-form__input--quantity form-control hide">
                                      <button type="submit" aria-label="Add to cart" class="dz-cart-btn dz-no-btn" style="${add_to_cart_label.toLowerCase() === 'sold out' ? 'cursor: default; background: black;' : ''}" ${add_to_cart_label.toLowerCase() === 'sold out' ? 'disabled' : ''}>
                                            <span data-add-to-cart-text>
                                                <span class="icon">
                                                    <svg width="17" height="21" viewBox="0 0 17 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                      <path d="M12.2449 5.31788V3.86884C12.2449 1.9605 10.6632 0.407959 8.71907 0.407959C6.77496 0.407959 5.19331 1.9605 5.19331 3.86884V5.31788H0.751953V20.9589H16.6862V5.31788H12.2449ZM6.28706 3.86884C6.28706 2.55249 7.37805 1.48158 8.71907 1.48158C10.0601 1.48158 11.1511 2.55249 11.1511 3.86884V5.31788H6.28706V3.86884ZM15.5924 19.8853H1.8457V6.3915H5.19331V7.95993C5.19331 8.25642 5.43818 8.49674 5.74019 8.49674C6.04219 8.49674 6.28706 8.25642 6.28706 7.95993V6.3915H11.1511V7.95993C11.1511 8.25642 11.396 8.49674 11.698 8.49674C12 8.49674 12.2449 8.25642 12.2449 7.95993V6.3915H15.5925V19.8853H15.5924Z" fill="white"/>
                                                    </svg>
                                                </span>
                                                <span>${ add_to_cart_label }</span>
                                            </span>
                                            <span class="hide" data-loader>
                                                <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-spinner" viewBox="0 0 20 20"><path d="M7.229 1.173a9.25 9.25 0 1 0 11.655 11.412 1.25 1.25 0 1 0-2.4-.698 6.75 6.75 0 1 1-8.506-8.329 1.25 1.25 0 1 0-.75-2.385z" fill="#919EAB"/></svg>
                                            </span>
                                        </button>
                                    </form>
                                </div>
                            </div>`;

                        jQuery("#regime-result-recommendation .result-recommendation-products").append(single_rc);
                    });
                }
            }
        }
       
    });
})(jQuery, this);